<template>
  <div class="product-detail-header-cover">
    <ym-img class="product-cover"
            :src="src"
            :alt="alt"
    />

<!--2024-06-07隐藏“赚积分”-->
<!--    <div v-if="showGetPoint"-->
<!--         class="get-point"-->
<!--         @click="handleGetPoint"-->
<!--    >-->
<!--      <ym-img class="point-coin"-->
<!--              :src="require('@/assets/img/user_center/point_coin.png')"-->
<!--      />-->
<!--      <span>赚积分</span>-->
<!--    </div>-->
  </div>
</template>

<script>
  import { Image } from '@ymba/ym-ui';
  import { projectJump } from '@/utils';

  export default {
    name: 'ProductDetailHeaderCover',
    components: {
      'ym-img': Image,
    },
    props: {
      src: {
        type: String,
        required: true,
      },
      alt: {
        type: String,
        default: '产品封面',
      },
      targetId: {
        type: Number,
        default: 0,
      },
      targetType: {
        type: String,
        default: '',
      },
      showGetPoint: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleGetPoint() {
        const { targetId, targetType } = this;
        projectJump({
          name: 'PointShareProduct',
          params: {
            targetId,
            targetType,
          },
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-header-cover {
    position: relative;
    width: 100%;
    background-color: @background-color-base;
  }

  .product-cover {
    display: block;
    width: 100%;
  }

  .get-point {
    position: absolute;
    top: @size-small;
    right: 0;
    padding-left: 16px;
    width: 126px;
    height: @size-extra-medium;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-radius: @border-radius-medium 0 0 @border-radius-medium;
    background: @gradient-highlight;
    font-size: @font-size-extra-small;
    line-height: @size-extra-medium;
    color: @color-white;
    z-index: @z-index-extra-large;
    .point-coin {
      margin-right: 8px;
      width: @size-small;
      height: 24px;
    }
  }

</style>
